import React from 'react';
import {func, number, string} from 'prop-types';
import {EmptyFunc, parseContentEditable, textToCleanHTMLStr} from 'utils/DBUtils';

// From https://stackoverflow.com/questions/22677931/react-js-onchange-event-for-contenteditable/27255103#27255103
export default class ContentEditable extends React.Component {

  static propTypes = {
    html: string,
    valueLength: number,
    onBlur: func,
    onFocus: func,
    onChange: func,
    getTextLengthCallback: func,
    className: string,
    id: string,
    placeholder: string
  };

  static defaultProps = {
    html: '',
    onBlur: EmptyFunc,
    onFocus: EmptyFunc,
    onChange: EmptyFunc,
    getTextLengthCallback: EmptyFunc
  };

  constructor(props) {
    super(props);
    this.state = {
      valueLength: props.valueLength ? props.valueLength : 0
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.html !== this.node.innerHTML;
  }

  componentDidMount() {
    this.updateTextLength(this.node.innerHTML);
  }

  // updates different bits of state when innerHTML has changed.
  emitChange = () => {
    let html = this.node.innerHTML;

    // if the field contains only whitespace (or equiv.) then reset it
    if (html.match(/^(<br\/?>|\s)+$/)) {
      html = '';
      this.node.innerHTML = html;
    }

    if (html !== this.lastHtml) {
      this.props.onChange({
        target: {
          value: html
        }
      });
    }

    this.updateTextLength(html);
    this.lastHtml = html;
  };

  get isWhitespaceOnly() {
    return this.node.innerHTML.match(/^(&nbsp;|\s)+$/);
  }

  onBlur = event => {
    if (!this.isWhitespaceOnly) {
      this.props.onBlur({
        target: {
          value: this.node.innerHTML.trim()
        }
      });
    }
  };

  onFocus = event => {
    if (!this.isWhitespaceOnly) {
      this.props.onFocus({
        target: {
          value: this.node.innerHTML.trim()
        }
      });
    }
  };

  // intercepts paste data in transit to strip MS Word formatting.
  onPaste = event => {
    event.preventDefault(); // cancel 'input' event

    const clipboardData = event.clipboardData.getData('text/html');
    const docStr = textToCleanHTMLStr(clipboardData);
    const pTagWrapper = /^<p>(.+)<\/p>$/;

    if (docStr === "") {
      // No html produced, but we're going to assume user was trying to paste something so use plain text
      document.execCommand('inserttext', false, event.clipboardData.getData('text/plain'));
    } else if (docStr.match(pTagWrapper)) {
      // html was produced but it's wrapped in <p> tags, so unwrap it.
      // handles the case of accordion titles not rendering, since <p> pushes them out of view.
      const unwrapped = docStr.replace(pTagWrapper, (_, captureGroup) => captureGroup);
      document.execCommand('insertHTML', false, unwrapped);
    } else {
      document.execCommand('insertHTML', false, docStr);
    }

    setTimeout(this.onBlur, 0);
  };

  updateTextLength = html => {
    const valueLength = parseContentEditable(html).length;
    this.setState({valueLength}, () => this.props.getTextLengthCallback(this.state.valueLength));
  };

  render() {
    let className = 'ui contenteditable';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }

    return (
      <div id={this.props.id}
           ref={node => this.node = node}
           className={className}
           onBlur={this.onBlur}
           onFocus={this.onFocus}
           onPaste={this.onPaste}
           onInput={this.emitChange}
           contentEditable={!this.props.disabled}
           spellCheck={true}
           placeholder={this.props.placeholder}
           dangerouslySetInnerHTML={{__html: this.props.html}}>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./public/components/forms/BasicFormFields/ContentEditable.jsx